export const endPoints = {
	'/home': `/`,
	'/404': `/404`,
	'/500': `/500`,
	'/kit': `/kit`,
	'/search': `/search`,
	'/stores': `/stores`,
	'/license': `/license`,
	'/download': `/download`,
	'/merchant': `/merchant`,
	'/create-store': `/create-store`,
	'/shopping-guide': `/shopping-guide`,
	'/about-us': `/about-us`,
	'/contact-us': `/contact-us`,
	'/organization': `/organization`,
	'/application': `/application`,
	'/guide-credit': `/guide-credit`,
	'/rule': `/rule`,
	'/FAQ': `/FAQ`,
	'/purchase-guide': '/purchase-guide',
	'/wallet-guide': '/wallet-guide',
	'/create-organization': `organization`,
	'/jobs': '/https://jobinja.ir/companies/Keepa/jobs',
	'/medu': '/landing/medu',
	'/fara': '/landing/fara',
	'/registration': '/landing/medu/registration',
	'/otp': '/landing/medu/otp',
	'/success': '/landing/medu/success',
	'/snowa': '/landing/snowa',
	'/failed': '/landing/medu/failed',
};

export const paths = endPoints;
